import { useEffect, useState } from "react";
import Lenis from "lenis";
import { AnimatePresence } from "framer-motion";
import Preloader from "@/components/Preloader";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Stats from "@/components/Stats";
import Timeline from "@/components/Timeline";
import Services from "@/components/Services";
import BrandDeals from "@/components/BrandDeals";
import BrandPartners from "@/components/BrandPartners";
import Manifesto from "@/components/Manifesto";
import Founder from "@/components/Founder";
import Sourcing from "@/components/Sourcing";
import Products from "@/components/Products";
import OrderFlow from "@/components/OrderFlow";
import CaseStudies from "@/components/CaseStudies";
import Footer from "@/components/Footer";

export default function LandingPage() {
  const [loading, setLoading] = useState(true);
  const [content, setContent] = useState(null);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/content`)
      .then((r) => r.json())
      .then(setContent)
      .catch(() => {});
  }, []);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, anchors: true, smoothTouch: false });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    if (!content) return;
    if (content.seo_title) document.title = content.seo_title;
    if (content.seo_description)
      document.querySelector('meta[name="description"]')?.setAttribute("content", content.seo_description);
  }, [content]);

  return (
    <div className="bg-ink text-neutral-100 antialiased">
      <AnimatePresence>
        {loading && <Preloader onDone={() => setLoading(false)} />}
      </AnimatePresence>
      <div className="noise-overlay pointer-events-none fixed inset-0 z-[90] opacity-[0.05]" />
      <Navbar start={!loading} />
      <main>
        {content?.banner_enabled && content?.banner_text ? (
          <div
            data-testid="announcement-banner"
            className="border-b border-gold/30 bg-gradient-to-r from-gold/15 via-gold/25 to-gold/15 px-4 py-2.5 text-center font-mono text-[11px] tracking-[0.15em] text-goldlight"
          >
            {content.banner_text}
          </div>
        ) : null}
        <Hero start={!loading} content={content} />
        <Marquee />
        <Stats />
        <Timeline />
        <Services />
        <BrandDeals />
        <BrandPartners />
        <Manifesto />
        <Founder />
        <Sourcing />
        <Products />
        <OrderFlow />
        <CaseStudies />
        <Footer content={content} />
      </main>
    </div>
  );
}
